export default __webpack_public_path__ + "c17c8969f2852cf1ba78e527fa48188d.webp";